import { render, staticRenderFns } from "./TransactionModal.vue?vue&type=template&id=b7dd676a&scoped=true&"
import script from "./TransactionModal.vue?vue&type=script&lang=js&"
export * from "./TransactionModal.vue?vue&type=script&lang=js&"
import style0 from "./TransactionModal.vue?vue&type=style&index=0&id=b7dd676a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7dd676a",
  null
  
)

export default component.exports